// @core/api/endpoints/payment/delete_payment_method.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/payment';

/**
 * Delete payment method
 * Removes a payment method and invalidates all provider tokens. Default method cannot be deleted.
 */
export async function DeletePaymentMethod(
  billingAccountId: string,
  paymentMethodId: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/billing-accounts/:billingAccountId/payment-methods/:paymentMethodId`;
  requestPath = requestPath.replace(':billingAccountId', encodeURIComponent(billingAccountId));
  requestPath = requestPath.replace(':paymentMethodId', encodeURIComponent(paymentMethodId));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
